

// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import Header from "./Header";
// import "./Layout.css";

// // Added 'shouldCollapse' prop to listen for external triggers (like the Report Panel opening)
// export default function Layout({
//   children,
//   searchQuery,
//   setSearchQuery,
//   fullWidth = false,
//   shouldCollapse = false,
// }) {
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   const location = useLocation();

//   // Trigger collapse if the parent component requests it (e.g. when Report Panel opens)
//   useEffect(() => {
//     if (shouldCollapse) {
//       setIsCollapsed(true);
//     }
//   }, [shouldCollapse]);

//   const toggleSidebar = () => {
//     if (window.innerWidth <= 768) {
//       setIsMobileMenuOpen(!isMobileMenuOpen);
//     } else {
//       setIsCollapsed(!isCollapsed);
//     }
//   };

//   const showHeader = location.pathname === "/mainPage";

//   return (
//     <div className="app-layout">
//       {/* Sidebar controls its own mobile state via props */}
//       <Sidebar
//         isMobileMenuOpen={isMobileMenuOpen}
//         setIsMobileMenuOpen={setIsMobileMenuOpen}
//         isCollapsed={isCollapsed}
//         toggleSidebar={toggleSidebar}
//       />

//       <div
//         className={`main-wrapper ${
//           isCollapsed ? "collapsed-sidebar" : "expanded-sidebar"
//         }`}
//       >
//         {showHeader && (
//           <Header
//             searchQuery={searchQuery}
//             setSearchQuery={setSearchQuery}
//             // Pass the setter to Header so the menu icon works
//             setIsMobileMenuOpen={setIsMobileMenuOpen}
//           />
//         )}

//         <main className={fullWidth ? "page-content-full" : "page-content"}>
//           {children}
//         </main>
//       </div>
//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import "./Layout.css";

// Added 'shouldCollapse' prop to listen for external triggers (like the Report Panel opening)
export default function Layout({
  children,
  searchQuery,
  setSearchQuery,
  fullWidth = false,
  shouldCollapse = false,
}) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const location = useLocation();

  // Trigger collapse if the parent component requests it (e.g. when Report Panel opens)
  useEffect(() => {
    if (shouldCollapse) {
      setIsCollapsed(true);
    }
  }, [shouldCollapse]);

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    } else {
      setIsCollapsed(!isCollapsed);
    }
  };

  return (
    <div className="app-layout">
      {/* Sidebar controls its own mobile state via props */}
      <Sidebar
        isMobileMenuOpen={isMobileMenuOpen}
        setIsMobileMenuOpen={setIsMobileMenuOpen}
        isCollapsed={isCollapsed}
        toggleSidebar={toggleSidebar}
      />

      <div
        className={`main-wrapper ${ isCollapsed ? "collapsed-sidebar" : "expanded-sidebar"
          }`}
      >
        {/* Header is now rendered on ALL pages */}
        <Header
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          // Pass the setter to Header so the menu icon works
          setIsMobileMenuOpen={setIsMobileMenuOpen}
        />

        <main className={fullWidth ? "page-content-full" : "page-content"}>
          {children}
        </main>
      </div>
    </div>
  );
}